import { render } from "./Informacao-Gerais.vue?vue&type=template&id=46606832&scoped=true"
import script from "./Informacao-Gerais.vue?vue&type=script&lang=js"
export * from "./Informacao-Gerais.vue?vue&type=script&lang=js"

import "./Informacao-Gerais.vue?vue&type=style&index=0&id=46606832&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46606832"]])

export default __exports__